export default __webpack_public_path__ + "static/media/third-party.6bbb413e.svg";